import * as types from './personal-note.types';
import * as constants from './personal-note.constants';
import { generateResourceReducer } from '../generators/resource.reducer';

export const personalNoteReducer = generateResourceReducer<types.IPersonalNote>({
  STORE: constants.STORE_PERSONAL_NOTE,
  CLEAR: constants.CLEAR_PERSONAL_NOTE,
});
